import styles from './Sitemap.module.css';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

// SEO-optimized sitemap data with priorities and descriptions
const quickLinks = [
    { to: '/', label: 'Home', description: 'CloTech AI - Custom AI & Cloud CRM Solutions', priority: 'high' },
    { to: '/about', label: 'About Us', description: 'Learn about CloTech AI\'s vision and leadership team', priority: 'high' },
    { to: '/services', label: 'Services', description: 'Custom CRM development and AI integration services', priority: 'high' },
    { to: '/plans', label: 'Plans & Pricing', description: 'Flexible CRM solution plans for all business sizes', priority: 'medium' },
    { to: '/careers', label: 'Careers', description: 'Join our team of technology innovators', priority: 'medium' },
    { to: '/investor-relation', label: 'Investor Relations', description: 'Investment opportunities in CloTech AI', priority: 'medium' },
    { to: '/partner', label: 'Partner With Us', description: 'Partnership opportunities and collaborations', priority: 'medium' },
    { to: '/contact', label: 'Contact Us', description: 'Get in touch with CloTech AI team', priority: 'high' },
];

const legalLinks = [
    { to: '/privacy-policy', label: 'Privacy Policy', description: 'How we protect your data and privacy', priority: 'low' },
    { to: '/terms-and-conditions', label: 'Terms & Conditions', description: 'Terms of service and conditions of use', priority: 'low' },
    { to: '/cancellation-refund-policy', label: 'Cancellation & Refund Policy', description: 'Our cancellation and refund policies', priority: 'low' },
    { to: '/service-delivery-policy', label: 'Service Delivery Policy', description: 'How we deliver our services', priority: 'low' },
    { to: '/cookie-policy', label: 'Cookie Policy', description: 'Information about cookies and tracking', priority: 'low' },
];

const supportLinks = [
    { to: '/faq', label: 'Frequently Asked Questions (FAQ)', description: 'Common questions about our CRM solutions', priority: 'medium' },
];

function LinkList({ links, title }) {
    return (
        <div className={styles.linkSection}>
            <ul className={styles.linkList}>
                {links.map(link => (
                    <li key={link.to} className={styles.linkItem}>
                        <Link to={link.to} className={styles.linkTitle}>
                            {link.label}
                        </Link>
                        {link.description && (
                            <p className={styles.linkDescription}>{link.description}</p>
                        )}
                        <span className={styles.linkPriority}>Priority: {link.priority}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default function Sitemap() {
    useEffect(() => {
        window.scrollTo(0, 0);

        // Update page title and meta description for SEO
        document.title = 'Sitemap - CloTech AI | All Pages Directory';
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', 'Complete sitemap of CloTech AI website. Find all pages including services, about us, contact, privacy policy and more.');
        }
    }, []);

    return (
        <div className={`${styles.sitemap} container`}>
            <section className={styles.sitemapHeader}>
                <h1>Website Sitemap</h1>
                <p className={styles.sitemapDescription}>
                    Navigate through all pages of CloTech AI website. Find information about our CRM solutions,
                    company details, services, legal policies, and support resources.
                </p>
            </section>

            <section className={styles.sitemapSection}>
                <h2><i className="fas fa-home"></i> Main Pages</h2>
                <LinkList links={quickLinks} title="Main Pages" />
            </section>

            <section className={styles.sitemapSection}>
                <h2><i className="fas fa-gavel"></i> Legal & Policies</h2>
                <LinkList links={legalLinks} title="Legal & Policies" />
            </section>

            <section className={styles.sitemapSection}>
                <h2><i className="fas fa-question-circle"></i> Support & Help</h2>
                <LinkList links={supportLinks} title="Support & Help" />
            </section>

            <section className={styles.xmlSitemap}>
                <h2><i className="fas fa-code"></i> XML Sitemap</h2>
                <p>
                    For search engines and automated tools, access our machine-readable XML sitemap at:{' '}
                    <a href="/sitemap.xml" className={styles.xmlLink} target="_blank" rel="noopener noreferrer">
                        https://www.clotechai.com/sitemap.xml
                    </a>
                </p>
            </section>
        </div>
    );
}
